import { useRollbar } from '@rollbar/react';
import Rollbar from 'rollbar';

export default function useSafeRollbar() {
  const rollbar: Rollbar =
    process.env.NODE_ENV === 'development'
      ? ({
          debug: () => {},
          info: () => {},
          error: () => {},
          warn: () => {},
          critical: () => {},
          log: () => {},
        } as Rollbar)
      : useRollbar();
  return rollbar;
}
